"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SubtitleLayout = require("./SubtitleLayout");
Object.keys(_SubtitleLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SubtitleLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SubtitleLayout[key];
    }
  });
});